module.exports = __webpack_public_path__ + "static/media/allstate_logo.50d15403.png";